import { useEffect } from 'react';
import { Layer, Source, useMap } from 'react-map-gl';
import { fireFillConfig } from 'configs/map/common';
import { FIRE_LAYER, FIRE_STATIC_LAYER } from 'constants/map';
import { GEOCONFIRMED_OBJECT_DETAILS_POPUP } from 'constants/modals';
import { useAppDispatch, useAppSelector, useMarkerPopup } from 'hooks';
import fireIcon from 'images/raster/fireIcon.png';
import { getFiresThunk } from 'store/slices/mapV2/tabsReducer/operationalSlice/actions';
import {
  objectsSelector,
  rangeSelector,
} from 'store/slices/mapV2/tabsReducer/operationalSlice/selectors';

import { formatDate } from 'utils';

import { GeoconfirmedObjectPreviewPopup } from '../GeoconfirmedObjectsSource/GeoconfirmedObjectsPreviewPopup';

export const FireSource: React.FC = () => {
  const dateRange = useAppSelector(rangeSelector);
  const objects = useAppSelector(objectsSelector);

  const dispatch = useAppDispatch();

  const { current: map } = useMap();
  const { featureData, isPopupOpen, mapTypes, onClose } = useMarkerPopup(
    map,
    FIRE_LAYER,
    GEOCONFIRMED_OBJECT_DETAILS_POPUP,
    'fire'
  );

  const [dateStart, dateEnd] = dateRange;
  const showFire = mapTypes.fire.active;
  const firesData = objects.fires?.features ?? [];

  useEffect(() => {
    if (!map) return;

    if (!map.hasImage('fire-icon')) {
      map.loadImage(fireIcon, (error, image) => {
        if (error || !image) return;

        map.addImage('fire-icon', image);
      });
    }
  }, [map]);

  useEffect(() => {
    if (!dateStart || !dateEnd) return;

    dispatch(
      getFiresThunk({
        fdate: formatDate(dateStart),
        tdate: formatDate(dateEnd),
      })
    );
  }, [dateStart, dateEnd, dispatch]);

  if (!showFire) return null;

  return (
    <>
      {firesData && (
        <>
          <Source
            type="geojson"
            data={{
              type: 'FeatureCollection',
              features: firesData,
            }}
          >
            <Layer
              id={FIRE_LAYER}
              beforeId={FIRE_STATIC_LAYER}
              {...fireFillConfig}
            />
          </Source>
        </>
      )}
      {isPopupOpen && featureData && (
        <GeoconfirmedObjectPreviewPopup
          key={Date.now()}
          object={featureData}
          onClose={onClose}
          showOnlyDate={true}
        />
      )}
    </>
  );
};
